import { ROUTES } from '../constants/config';

/**
 * "Hydrochloric Acid" -> "hydrochloric-acid"
 */
export function slugify(text) {
  return text
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function buildElementPath(substance) {
  return `${ROUTES.ELEMENTS}/${slugify(substance.name)}`;
}

export function buildReactionPath(firstSubstance, secondSubstance) {
  return `${ROUTES.REACTIONS}/${slugify(firstSubstance.name)}-and-${slugify(secondSubstance.name)}`;
}

export function buildWorksheetPath(worksheet) {
  return `${ROUTES.WORKSHEETS}/${worksheet.slug}`;
}

export function buildWorksheetAnswersPath(worksheet) {
  return `${buildWorksheetPath(worksheet)}/answers`;
}

/**
 * Link to the lab with substances already picked: "/?pick=K,H2O".
 */
export function buildLabPath(substanceIds = []) {
  return substanceIds.length ? `${ROUTES.LAB}?pick=${substanceIds.map(encodeURIComponent).join(',')}` : ROUTES.LAB;
}

export function readPickedIds(search) {
  const picked = new URLSearchParams(search).get('pick');
  return picked ? picked.split(',').filter(Boolean) : [];
}

/**
 * Removes a trailing slash so "/about/" and "/about" are the same page.
 */
export function normalizePath(path) {
  return path.length > 1 ? path.replace(/\/+$/, '') : path;
}

/**
 * Works out which page a path belongs to: { page: 'element', slug: 'iron' }.
 */
export function matchRoute(path) {
  const normalizedPath = normalizePath(path);
  const staticPages = {
    [ROUTES.LAB]: 'lab',
    [ROUTES.ABOUT]: 'about',
    [ROUTES.ELEMENTS]: 'elements',
    [ROUTES.REACTIONS]: 'reactions',
    [ROUTES.PRIVACY]: 'privacy',
    [ROUTES.TERMS]: 'terms',
    [ROUTES.CONTACT]: 'contact',
    [ROUTES.PARENTS]: 'parents',
  };
  if (staticPages[normalizedPath]) return { page: staticPages[normalizedPath] };
  const elementMatch = normalizedPath.match(/^\/elements\/([a-z0-9-]+)$/);
  if (elementMatch) return { page: 'element', slug: elementMatch[1] };
  const reactionMatch = normalizedPath.match(/^\/reactions\/([a-z0-9-]+)$/);
  if (reactionMatch) return { page: 'reaction', slug: reactionMatch[1] };
  const worksheetMatch = normalizedPath.match(/^\/worksheets\/([a-z0-9-]+)(\/answers)?$/);
  if (worksheetMatch) return { page: worksheetMatch[2] ? 'worksheet-answers' : 'worksheet', slug: worksheetMatch[1] };
  return { page: 'not-found' };
}
